
/**
 * Flattens the collection.
 *
 * @param {Array}  collection Collection.
 * @param {string} childrenKey Children key.
 * @returns {Array} Flattened collecion.
 */
export const flatten = (collection, childrenKey = 'children') =>
    collection.reduce((acc, item) => [
        ...acc,
        item,
        ...(item[childrenKey] ? flatten(item[childrenKey], childrenKey) : []),
    ], []);
